"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFullscreenClose = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconFullscreenClose = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.003 2l-6.076 5.77V4.041h-1.26v5.77h6.077V8.616h-3.927l6.077-5.77zM4.178 15.442h3.926l-6.077 5.77.89.846 6.078-5.77v3.728h1.26v-5.77H4.178z",
  fillRule: "evenodd"
}));
exports.IconFullscreenClose = IconFullscreenClose;
//# sourceMappingURL=IconFullscreenClose.js.map